import { type FunctionComponent, type ReactNode, useCallback, useRef, useState } from 'react';

import ConfirmationDialog from 'shared/ConfirmationDialog';

import ConfirmDialogContext from './ConfirmDialogContext';
import type { IConfirmDialogOptions, IConfirmDialogResult } from './types';

const ConfirmDialogProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [options, setOptions] = useState<IConfirmDialogOptions>({
    title: '',
    closeLabel: '',
    message: '',
    onActionLabel: '',
  });
  const resolveRef = useRef<(result: IConfirmDialogResult) => void>(() => {});

  const openDialog = useCallback((options: IConfirmDialogOptions) => {
    setOptions(options);
    setOpen(true);

    return new Promise<IConfirmDialogResult>((resolve) => {
      resolveRef.current = resolve;
    });
  }, []);

  const onActionClick = () => {
    setOpen(false);
    resolveRef.current({
      confirmed: true,
    });
  };

  const onClose = () => {
    setOpen(false);
    resolveRef.current({
      confirmed: false,
    });
  };

  return (
    <>
      <ConfirmDialogContext.Provider value={openDialog}>{children}</ConfirmDialogContext.Provider>

      <ConfirmationDialog open={open} onAction={onActionClick} onClose={onClose} {...options} />
    </>
  );
};

export default ConfirmDialogProvider;
